<template>
  <div class="price-card">
    <div class="price-card-header">
      <div class="text-center total-price bg-primary text-white h3 mb-0 py-2">
        <small class="mr-1">総工事費&emsp;¥</small
        >{{ grandTotal.toLocaleString() }}
      </div>
    </div>
    <div class="price-card-body">
      <div
        v-for="(detail, i) in priceDetail"
        :key="i"
        class="price-card-section p-2"
      >
        <dl class="form-row no-gutters mb-0">
          <dt class="col-4 text-primary">{{ i + 1 }}台目の工事費</dt>
          <dd class="col-8 text-right h3 text-primary pt-1">
            <small class="mr-1">¥</small>{{ detail.total.toLocaleString() }}
          </dd>
          <dt class="col-5">取外料金</dt>
          <dd class="col-7 text-right">
            ¥{{ detail.removal.toLocaleString() }}
          </dd>
          <dt class="col-5">リサイクル料金</dt>
          <dd class="col-7 text-right">
            ¥{{ detail.recycling.toLocaleString() }}
          </dd>
          <dt class="col-5">標準工事費</dt>
          <dd class="col-7 text-right">
            ¥{{ detail.standard.toLocaleString() }}
          </dd>
          <dt class="col-5">追加工事費</dt>
          <dd class="col-7 text-right">
            ¥{{ detail.additional.toLocaleString() }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
  <!-- /.price-card -->
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      modalShow: false,
    };
  },
  computed: {
    ...mapState({
      total() {
        return this.$store.getters.total;
      },
      removal() {
        return this.$store.getters.removal;
      },
      recycling() {
        return this.$store.getters.recycling;
      },
      standard() {
        return this.$store.getters.standard;
      },
      additional() {
        return this.$store.getters.additional;
      },
      priceDetail() {
        return this.$store.getters.priceDetail;
      },
      grandTotal() {
        return this.$store.getters.grandTotal;
      },
      currentStep() {
        return this.$store.getters.currentStep;
      },
    }),
  },
};
</script>
